import Grid2 from "@mui/material/Grid2";
import {
	ShiftSelectorModal,
	FormAssetSelectorModal,
	ProductionDateSelectorModal,
} from "../filters";
import { Questions } from "./Questions";

export const ProductionDateStep = () => (
	<Grid2 container justifyContent="center">
		<Grid2 size={{ md: 4, xs: 12 }}>
			<ProductionDateSelectorModal />
		</Grid2>
	</Grid2>
);
export const ShiftStep = () => (
	<Grid2 container justifyContent="center">
		<Grid2 size={{ md: 4, xs: 12 }}>
			<ShiftSelectorModal />
		</Grid2>
	</Grid2>
);

export const FormAndAssetStep = () => (
	<Grid2 container justifyContent="center">
		<Grid2 size={{ md: 4, xs: 12 }}>
			<FormAssetSelectorModal />
		</Grid2>
	</Grid2>
);

export const QuestionsStep = () => <Questions />;
